export default "__VITE_ASSET__Dtl8Vi9s__"